import Navbar from './components/navbar/Navbar';
import './App.scss';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from './routes/Home';
import EmbTest from "./routes/EmbTest";
import Services from './routes/Services';
import AboutMe from './routes/AboutMe';
import Footer from './components/footer/Footer';
import Contact from './routes/Contact';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/emb-test",
    element: <EmbTest />
  }, 
  {
    path: "aanbod",
    element: <Services />
  },
  {
    path: "over-mij",
    element: <AboutMe />
  },
  {
    path: "contact",
    element: <Contact />
  }
]);

function App() {
  return (
    <div className="App">
      <Navbar />
      <RouterProvider router={router} />
      <Footer></Footer>
    </div>
  );
}

export default App;
